<template>
	<c-dialog ref="dialog" :title="lnglat ? '查看位置' : '选择位置'" width="1000" height="750" enable-flex :button="false">
		<div class="map flex-grow flex-column">
			<c-map ref="map" class="flex-grow" style="border-radius: 0 0 10px 10px;"></c-map>
			<dl v-if="!lnglat" class="map-search">
				<dt class="flex-center">
					<input v-model="keyword" class="flex-grow" placeholder="搜索位置" @keydown.enter="searchHandle">
					<a v-if="keyword" class="flex-center" @click="clearHandle"><i class="c-icon-cross"></i></a>
					<a class="flex-center" @click="searchHandle"><i class="c-icon-search"></i></a>
				</dt>
				<dd v-show="emptyState || searchList.length">
					<c-empty v-if="emptyState"></c-empty>
					<template v-if="searchList.length">
						<ul>
							<li v-for="(item, i) in searchList" :key="i" class="flex-center" @click="focusHandle(item)">
								<div class="flex-grow">
									<h5 class="ellipsis">{{i + 1}}. {{item.name}}</h5>
									<p class="ellipsis">{{item.address}}</p>
								</div>
								<c-button @click.native.stop="selectHandle(item)">选择</c-button>
							</li>
						</ul>
						<div class="page flex-between-center">
							<p>共{{total}}条结果</p>
							<div class="flex-center">
								<c-link class="c-icon-page-top" :class="{'z-dis': pageIndex <= 1}" :color="false" @click="_localsearch.firstPage()"></c-link>
								<c-link class="c-icon-tri-left" :class="{'z-dis': pageIndex <= 1}" :color="false" @click="_localsearch.previousPage()"></c-link>
								<c-link class="c-icon-tri-right" :class="{'z-dis': pageIndex >= pageCount}" :color="false" @click="_localsearch.nextPage()"></c-link>
								<c-link class="c-icon-page-bottom" :class="{'z-dis': pageIndex >= pageCount}" :color="false" @click="_localsearch.lastPage()"></c-link>
							</div>
						</div>
					</template>
				</dd>
			</dl>
		</div>
	</c-dialog>
</template>

<script>
	import CoordTrans from '@/assets/script/coord_trans.js'

	export default {
	    name: 'locationSelector',

		props: {
			lnglat: String
		},

		data() {
			return {
				keyword: '',
				searchList: [],
				emptyState: false,

				total: 0,
				pageIndex: 1,
				pageCount: 1
			}
		},

		methods: {
			open(data = {}) {
				this.$refs.dialog.open();
				this.$refs.map.init(data.center ? {
					zoom: 15,
					center: data.center
				} : undefined, map => {
					this._map = map;
					this.clearHandle();

					if (this.lnglat) {
						let lnglat = this.lnglat.split(',');
						let {lng, lat} = CoordTrans.gcj2Cgcs(lnglat[0], lnglat[1]);
						this.setMarks([{
							lonlat: `${lng},${lat}`
						}], 'init');
						map.setViewport([new T.LngLat(lng, lat)]);
						return;
					}

					if (!this._localsearch) {
						this._localsearch = new T.LocalSearch(map, {
							pageCapacity: 8,
							onSearchComplete: this.searchResolve
						});
						this._geocoder = new T.Geocoder();
						map.addEventListener('click', e => {
							map.clearOverLays();
							this._geocoder.getLocation(e.lnglat, res => {
								this.setMarks([{
									lonlat: `${e.lnglat.getLng()},${e.lnglat.getLat()}`,
									name: res.getAddressComponent().address,
									address: res.getAddress()
								}], 'click');
								this.keyword = '';
								this.total = 1;
								this.pageCount = 1;
								this.pageIndex = 1;
							});
						});
					}
					if (data.center) {
						let {lng, lat} = CoordTrans.gcj2Cgcs(data.center[0], data.center[1]);
						this.setMarks([{
							lonlat: `${lng},${lat}`
						}], 'init');
					}
				});
			},

			searchHandle() {
				if (!this.keyword.trim()) {
					this.$message({
						message: '请输入搜索内容'
					})
					return;
				}
				this.searchList = [];
				this.emptyState = false;
				this._localsearch.search(this.keyword.trim());
			},

			clearHandle() {
				this.keyword = '';
				this.searchList = [];
				this.emptyState = false;
				this._map.clearOverLays();
			},

			searchResolve(res) {
				switch (parseInt(res.getResultType())) {
				case 1:
					this.setMarks(res.getPois());
					break;
				case 3:
					let area = res.getArea();
					let point = area.lonlat.split(',');
					this._map.centerAndZoom(new T.LngLat(point[0], point[1]), area.level);
					this.clearHandle();
					this.$message({
						message: `已为您定位到${area.name}`
					});
					break;
				default:
					this.emptyHandle();
					break;
				}

				this.total = this._localsearch.getCountNumber();
				this.pageCount = this._localsearch.getCountPage();
				this.pageIndex = this._localsearch.getPageIndex();
			},

			setMarks(list, type) {
				this._map.clearOverLays();
				if (!list || !list.length) {
					this.emptyHandle();
					return;
				}
				let points = [];
				list.forEach((item, index) => {
					let [lng, lat] = item.lonlat.split(',');
					let dom = $([
						'<div class="marker flex-center">',
							type == 'init' ? '' : `<p>${index + 1}</p>`,
						'</div>',
					].join(''));
					if (type != 'init') {
						dom.addClass('marker-result').click(() => {
							this.selectHandle(item);
						});
					}
					this.$refs.map.overlay(lng, lat, dom[0], {
						type: 'cgcs',
						offsetY: '5px'
					});
					points.push(new T.LngLat(lng, lat));
				});
				if (type != 'init') {
					this.searchList = list;
					if (type != 'click') {
						this._map.setViewport(points);
					}
				}
			},

			focusHandle(item) {
				let [lng, lat] = item.lonlat.split(',');
				this._map.centerAndZoom(new T.LngLat(lng, lat), this._map.getZoom());
			},

			selectHandle(item) {
				let [_lng, _lat] = item.lonlat.split(',');
				let {lng, lat} = CoordTrans.cgcs2Gcj(_lng, _lat);
				this.$emit('resolve', {
					lng,
					lat,
					address: item.address + item.name
				});
				this.$refs.dialog.close();
			},

			emptyHandle() {
				this.searchList = [];
				this.emptyState = true;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.map {
		position: relative;

		&-search {
			z-index: 999;
			position: absolute;
			left: 10px;
			top: 10px;

			dt {
				z-index: 1;
				position: relative;
				box-sizing: border-box;
				width: 300px;
				height: 44px;
				border-radius: 4px;
				padding: 0 4px 0 12px;
				background: #fff;
				box-shadow: 0 0 5px 0 rgba(0,0,0,.2);

				input {
					height: 100%;
				}

				a {
					width: 36px;
					font-size: 18px;
					color: #999;

					&:hover {
						color: var(--color-main);
					}
				}
			}

			dd {
				position: absolute;
				left: 0;
				top: 100%;
				box-sizing: border-box;
				width: 100%;
				border-radius: 4px;
				background: #fff;
				box-shadow: 0 0 5px 0 rgba(0,0,0,.2);

				ul {
					max-height: 50%;
					overflow: auto;

					li {
						border-bottom: 1px solid #eee;
						padding: 12px 20px;
						cursor: pointer;

						&:hover {
							background: #FAFAFA;
						}

						h5 {
							font-size: 15px;
							color: #333;
						}

						p {
							margin-top: 8px;
							line-height: 18px;
							font-size: 13px;
							color: #666;
						}

						>>> .c-button {
							display: none;
							margin-left: 10px;

							^[-1]:hover ^[-1..-1] {
								display: block;
							}
						}
					}
				}

				.page {
					height: 40px;
					padding: 0 12px;

					p {
						font-size: 12px;
						color: #666;
					}

					>>> .c-link {
						padding: 4px;
						margin-left: 2px;
						color: #333;

						&.z-dis {
							color: #bbb;
							cursor: not-allowed;
						}

						&:not(.z-dis):hover {
							color: var(--color-main);
						}
					}
				}
			}
		}

		>>> .marker {
			box-sizing: border-box;
			width: 40px;
			height: 40px;
			padding-bottom: 6px;
			font-size: 14px;
			color: #fff;
			background: url('~@/assets/image/point_red.png');
			background-size: 100% 100%;

			&-result {
				opacity: .8;
				cursor: pointer;
				
				&:hover {
					z-index: 9999;
					opacity: 1;
				}
			}
		}
	}
</style>